import { render, staticRenderFns } from "./addBatch.vue?vue&type=template&id=3701996b&scoped=true&"
import script from "./addBatch.vue?vue&type=script&lang=js&"
export * from "./addBatch.vue?vue&type=script&lang=js&"
import style0 from "./addBatch.vue?vue&type=style&index=0&id=3701996b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3701996b",
  null
  
)

export default component.exports